import { useCallback } from 'react'

import type { Service } from '~publish/contexts/AccountContext/graphqlEnums'
import {
  connectChannel,
  isChannelConnectionAvailable,
  toConnectableService,
} from '~publish/helpers/channelConnections'
import { recordRefreshAttempt } from '~publish/helpers/refreshAttemptTracker'

interface RefreshChannelArgs {
  channel: {
    id: string
    service: Service
    name: string
    apiVersion?: string | null
  }
  cta?: string
  destinationUrl?: string
}

export const useRefreshChannelConnection = (): ((
  args: RefreshChannelArgs,
) => void) => {
  return useCallback((args: RefreshChannelArgs) => {
    const service = toConnectableService(args.channel.service)

    if (!service || !isChannelConnectionAvailable()) {
      return
    }

    connectChannel({
      service,
      isRefreshingConnection: true,
      cta: args.cta,
      name: args.channel.name,
      selectedRefreshChannelId: args.channel.id,
      authMethod: args.channel.apiVersion ?? undefined,
      destinationUrl: args.destinationUrl,
    })

    recordRefreshAttempt(args.channel.id)
  }, [])
}
